import { useIntl } from 'react-intl';

import { FulfillmentStatus } from 'constants/enums';
import { useAppSelector } from 'hooks';
import { HorizontalStepper } from 'components/UI';
import {
  buildFulfillmentSteps,
  formatFulfillmentDay,
  getFulfillmentStepDetailLabel,
  getFulfillmentTrack
} from 'utils/fulfillment';

interface IFulfillmentStepperProps {
  device: IDeviceListItem;
}

export const FulfillmentStepper = ({ device }: IFulfillmentStepperProps) => {
  const { formatMessage } = useIntl();
  const locale = useAppSelector((state) => state.intl.locale);
  const steps = buildFulfillmentSteps(device, getFulfillmentTrack(device));
  if (!steps) return null;

  return (
    <div className="mb-4">
      <HorizontalStepper
        steps={steps.map((step) => ({
          id: step.status,
          label: getFulfillmentStepDetailLabel(formatMessage, step.status, step.providerStatus),
          date: step.reached ? formatFulfillmentDay(step.occurredAt, locale) : null,
          danger: step.status === FulfillmentStatus.EXCEPTION,
          dataTest: `device-fulfillment-step-${step.status}`
        }))}
        currentStepIndex={steps.map((step) => step.reached).lastIndexOf(true)}
        list={{
          ariaLabel: formatMessage({ id: 'devices.fulfillment.progress' }),
          completedText: formatMessage({ id: 'devices.fulfillment.stepCompleted' }),
          upcomingText: formatMessage({ id: 'devices.fulfillment.stepUpcoming' }),
          dataTest: `device-fulfillment-stepper-${device.deviceId}`
        }}
      />
    </div>
  );
};
